import axios from "axios";
import Config from "config";
import { SendGridEventStatus } from "enum/emailStatus.enum";
import { getHeaders } from "helpers/headers";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";
import { AnyAction } from "redux";
// Types
export interface Notification {
  id: number;
  email: string;
  subject: string;
  created_at: string;
  status: SendGridEventStatus;
}

export type payloadFetchEmailAuditLogs = {
  size?: number;
  page?: number;
  email?: string;
  subject?: string;
  created_at?: string;
  status?: SendGridEventStatus;
  sort?: string;
};

export interface EmailAuditLogsState {
  loading: boolean;
  error: string | null;
  content: Notification[];
  size: number;
  pages: number;
  total: number;
  page: number;
}

const initialState: EmailAuditLogsState = {
  loading: false,
  error: null,
  content: [],
  page: 0,
  size: 0,
  pages: 0,
  total: 0,
};

// Action Types
const FETCH_EMAIL_AUDIT_LOGS_REQUEST = "FETCH_EMAIL_AUDIT_LOGS_REQUEST";
const FETCH_EMAIL_AUDIT_LOGS_SUCCESS = "FETCH_EMAIL_AUDIT_LOGS_SUCCESS";
const FETCH_EMAIL_AUDIT_LOGS_FAILURE = "FETCH_EMAIL_AUDIT_LOGS_FAILURE";

// Reducer
export default function emailAuditLogsReducer(
  state = initialState,
  action: AnyAction
): EmailAuditLogsState {
  switch (action.type) {
    case FETCH_EMAIL_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        content: [],
      };

    case FETCH_EMAIL_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        content: action.payload.content,
        total: action.payload.total,
        pages: action.payload.pages,
        page: action.payload.page,
        size: action.payload.size,
      };

    case FETCH_EMAIL_AUDIT_LOGS_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}

// Thunk Action

export const fetchEmailAuditLogs: ThunkActionCreator<Promise<void>> =
  (payload: payloadFetchEmailAuditLogs) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_EMAIL_AUDIT_LOGS_REQUEST });
    let url = `${Config.API_SERVICE_URL}/api/notifications/email-status`;
    if (payload) {
      const qs = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          qs.append(key, String(value));
        }
      });
      url += `?${qs.toString()}`;
    }
    return axios
      .get(url, getHeaders())
      .then((response) => {
        dispatch({ type: FETCH_EMAIL_AUDIT_LOGS_SUCCESS, payload: response.data });
      })
      .catch(() => {
        dispatch({ type: FETCH_EMAIL_AUDIT_LOGS_FAILURE });
      });
  };
